"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UserProfileImageUploadDialogModule = /** @class */ (function () {
    function UserProfileImageUploadDialogModule() {
    }
    return UserProfileImageUploadDialogModule;
}());
exports.UserProfileImageUploadDialogModule = UserProfileImageUploadDialogModule;
